import React from "react";
import ReactDOM from "react-dom";
import Axios from "axios";
import App from "./App";
import APP_CONSTANTS from "./helper/constant/APP_CONSTANTS";
import * as serviceWorker from "./serviceWorker";
import "antd/dist/antd.css";
import 'react-lazy-load-image-component/src/effects/blur.css';
import "./style/_style.scss";
import "aos/dist/aos.css";
Axios.defaults.baseURL = APP_CONSTANTS.API_URL;


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
